query usuarioSelect($where: UsuarioModelFilterInput) {
    data: usuarios(
        where: $where 
        order: [{nome: ASC}]) {
        value: codigo
        label: nome
    }
}